import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../Common/Loading";
import popimg from "../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../Common/Images/ImagesForAlert/popup_close_n.png";

declare const fn_OnLoad: () => void;
declare const gfn_ClosePopup: () => void;

interface PointRow {
  AddedOn: string;
  SelMode: string;
  DicFileName: string;
  DicFileDesc: string;
  LessonCode: string;
  Activity: string;
  TimesDone: number;
  Score: number;
  Bricks: number;
  PointsEarned: number;
  PointsUsed: number;
  TotalPoints: number;
  BonusSource: string | null;
}

interface Summary {
  userName: string;
  currentAvatar: string;
  currentPoints: number;
  currentMonthUsage: string;
  bonusChestsAvailable: number;
  currentWeekPointsEarned: number;
}

const EL_ViewPoints: React.FC = () => {
  const [schoolCode, setSchoolCode] = useState("");
  const [familyCode, setFamilyCode] = useState("");
  const [login, setLogin] = useState("");
  const [rows, setRows] = useState<PointRow[]>([]);
  // http://localhost:3000/Support/EL_ViewPoints?C=DLR_KE_AU&F=login00001&L=Child11
  const [queryParams, setQueryParams] = useState({
    C: "",
    F: "",
    L: "",
  });


  const [summary, setSummary] = useState<Summary>({
    userName: "",
    currentAvatar: "",
    currentPoints: 0,
    currentMonthUsage: "",
    bonusChestsAvailable: 0,
    currentWeekPointsEarned: 0,
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const API_BASE =
    process.env.REACT_APP_DOCUMENT_LINK;

  document.body.style.margin = "0px";
  document.body.style.backgroundColor = "azure";

  const getLessonSelectionMode = (mode: string) => {
    switch (mode) {
      case "M":
        return "Manual";
      case "C":
        return "Set By Computer";
      case "T":
        return "Set By Teacher";
      default:
        return mode;
    }
  };

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);

    const sc = qs.get("SchoolCode") || qs.get("C") || "";
    const fc = qs.get("FamilyCode") || qs.get("F") || "";
    const lg = qs.get("Login") || qs.get("L") || "";

    setSchoolCode(sc);
    setFamilyCode(fc);
    setLogin(lg);

    loadPoints(sc, fc, lg);
  }, []);

  const loadPoints = async (sc = schoolCode, fc = familyCode, lg = login) => {
    setLoading(true);

    const res = await fetch(`${API_BASE}api/view-points/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        schoolCode: sc,
        familyCode: fc,
        login: lg,
      }),
    });

    const data = await res.json();

    setRows(data.rows || []);

    setSummary({
      userName: data.userName || "",
      currentAvatar: data.currentAvatar || "",
      currentPoints: data.currentPoints || 0,
      currentMonthUsage: data.currentMonthUsage || "",
      bonusChestsAvailable: data.bonusChestsAvailable || 0,
      currentWeekPointsEarned: data.currentWeekPointsEarned || 0,
    });

    setLoading(false);

    setTimeout(() => {
      if (typeof fn_OnLoad === "function") fn_OnLoad();
    }, 50);
  };

  const handleClose = () => {
    if (window.opener) {
        window.close();
    } else if (window.history.length > 1) {
        navigate(-1);
    } else {
        navigate("/");
    }
};

  const cellStyle = {
    borderLeft: "1px solid #80a0ff",
    // borderBottom: "1px solid #d9e6ff",
    whiteSpace: "nowrap" as const,
    overflow: "hidden" as const,
    textOverflow: "ellipsis" as const,
};

  return (
    <>

      {/* <div
        style={{
          backgroundImage: `url(${popimg}), url(${popbg})`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundPosition: "left center, right center",
          backgroundSize: "30% 100%, 70% 100%",
          height: "16px",
          color: "white",
          padding: "7px 0px",
          fontWeight: "bold",
          fontSize: "12pt",
          fontFamily: "arial",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ marginLeft: "10px" }}>
        </span>
        <img
          src={popclose}
          alt="close"
          height="30px"
          style={{ cursor: "pointer" }}
          onClick={() => window.close()}
        />
      </div> */}
      <div style={{ padding: "6px", height: "80vh" }}>
        {/* TOP BAR */}
        <table
          width="100%"
          cellPadding={6}
          cellSpacing={0}
          style={{
            backgroundColor: "azure",
            fontFamily: "Arial",
            fontSize: "13px",
          }}
        >
          <tbody>
            <tr style={{ fontSize: "13pt" }}>
              <td style={cellStyle}>
                SchoolCode:&nbsp;
                <input
                  value={schoolCode}
                  onChange={(e) => setSchoolCode(e.target.value)}
                  style={{ width: 190 }}
                />
              </td>
              <td style={cellStyle}>
                FamilyCode:&nbsp;
                <input
                  value={familyCode}
                  onChange={(e) => setFamilyCode(e.target.value)}
                  style={{ width: 180 }}
                />
              </td>
              <td style={cellStyle}>
                Login:&nbsp;
                <input
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                  style={{ width: 150 }}
                />
              </td>
              <td align="right" style={cellStyle}>
                <button
                  onClick={() => loadPoints()}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
                  style={{
                    background: "orange",
                    border: "1px solid blue",
                    padding: "2px 20px",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                >
                  VIEW
                </button>
              </td>
              <td align="right" style={cellStyle}>
                <button
                  onClick={handleClose}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
                  style={{
                    background: "orange",
                    border: "1px solid blue",
                    padding: "2px 12px",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                >
                  CLOSE
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        {/* SUMMARY BAR */}
        <div
          style={{
            marginTop: 6,
            padding: "6px",
            backgroundColor: "#c7ddfd",
            border: "1px solid #7aaeff",
            fontFamily: "Arial",
            fontSize: "10pt",
            textAlign: "center",
            color: "#2859ac",
            fontWeight: "bold",
          }}
        >
          <span>Points details for </span>
          <span style={{ color: "maroon", fontSize: "16px", fontWeight: "bold" }}>
            {summary.userName}
          </span>
          &nbsp;&nbsp; Current Points =
          <span style={{ color: "maroon", fontWeight: "bold", fontSize: "16px" }}>
            {" "}
            {summary.currentPoints}
          </span>
          &nbsp;&nbsp; Current Avatar =
          <span style={{ color: "maroon", fontWeight: "bold", fontSize: "16px" }}>
            {" "}
            {summary.currentAvatar}
          </span>
          &nbsp;&nbsp; Current Month Usage =
          <span style={{ color: "maroon", fontWeight: "bold", fontSize: "16px" }}>
            {" "}
            {summary.currentMonthUsage}
          </span>
          &nbsp;&nbsp; Bonus Chests Available =
          <span style={{ color: "maroon", fontWeight: "bold", fontSize: "16px" }}>
            {" "}
            {summary.bonusChestsAvailable}
          </span>
          &nbsp;&nbsp; Current Week Points Earned =
          <span style={{ color: "maroon", fontWeight: "bold", fontSize: "16px" }}>
            {" "}
            {summary.currentWeekPointsEarned}
          </span>
        </div>

        <div
          id="lst_divScrollableTable"
          style={{
            border: "1px solid #7aaeff",
            borderTop: "none",
            overflow: "auto",
            height: "84vh",
            backgroundColor: "white",
          }}
        >

          <table
            cellPadding={4}
            cellSpacing={0}
            style={{
              fontFamily: "Arial",
              fontSize: "11px",
              tableLayout: "fixed",
              width: "1700px",
              borderCollapse: "collapse"
            }}
          >
            <colgroup>
              <col style={{ width: "180px" }} />   {/* Done On */}
              <col style={{ width: "170px" }} />   {/* Lesson Selection Mode */}
              <col style={{ width: "140px" }} />   {/* DicFile */}
              <col style={{ width: "280px" }} />   {/* Dic File Name */}
              <col style={{ width: "140px" }} />   {/* LessonCode */}
              <col style={{ width: "150px" }} />   {/* Activity */}
              <col style={{ width: "90px" }} />    {/* Times Done */}
              <col style={{ width: "80px" }} />    {/* Score */}
              <col style={{ width: "80px" }} />    {/* Bricks */}
              <col style={{ width: "90px" }} />    {/* Earned */}
              <col style={{ width: "90px" }} />    {/* Used */}
              <col style={{ width: "90px" }} />    {/* Balance */}
              <col style={{ width: "500px" }} />   {/* Remarks */}
            </colgroup>
            <thead
              style={{
                backgroundColor: "#cfe3ff",
                fontWeight: "bold",
                color: "#2859ac",
                fontSize: "10pt",
                borderBottom: "1px solid #80a0ff"
              }}
            >
              {/* MAIN HEADER ROW */}
              <tr
                style={{
                  height: "35px",
                  position: "sticky",
                  top: 0,
                  zIndex: 3,
                  backgroundColor: "#cfe3ff",
                }}
              >

                <td rowSpan={2} style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Done On
                </td>
                <td rowSpan={2} style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Lesson Selection Mode
                </td>
                <td rowSpan={2} style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  DicFile
                </td>
                <td rowSpan={2} style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Dic File Name
                </td>
                <td rowSpan={2} style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  LessonCode
                </td>
                <td rowSpan={2} style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Activity
                </td>
                <td rowSpan={2} align="center" style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Times Done
                </td>
                <td rowSpan={2} align="center" style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Score
                </td>
                <td rowSpan={2} align="center" style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Bricks
                </td>

                {/* GROUP HEADER */}
                <td
                  colSpan={3}
                  align="center"
                  style={{ ...cellStyle, borderLeft: "1px solid #80a0ff", borderBottom: "1px solid #80a0ff" }}
                >
                  Points
                </td>

                <td rowSpan={2} style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Remarks
                </td>
              </tr>

              {/* SUB HEADER ROW */}
              <tr
                style={{
                  height: "35px",
                  position: "sticky",
                  top: "35px",
                  zIndex: 2,
                  backgroundColor: "#cfe3ff",
                }}
              >

                <td align="center" style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Earned
                </td>
                <td align="center" style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Used
                </td>
                <td align="center" style={{ ...cellStyle, borderLeft: "1px solid #80a0ff" }}>
                  Balance
                </td>
              </tr>
            </thead>

            <tbody>
              {rows.map((r, i) => (
                <tr
                  key={i}
                  style={{
                    backgroundColor: i % 2 === 0 ? "#f4faff" : "white",
                    fontSize: "10pt",
                    height: "35px",
                  }}
                >
                  <td style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}>
                    {new Date(r.AddedOn).toLocaleString()}
                  </td>
                  <td style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}>
                    {getLessonSelectionMode(r.SelMode)}
                  </td>

                  <td style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}>
                    {r.DicFileName}
                  </td>
                  <td style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}>
                    {r.DicFileDesc}
                  </td>
                  <td style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}>
                    {r.LessonCode}
                  </td>
                  <td style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}>
                    {r.Activity}
                  </td>
                  <td
                    style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}
                    align="center"
                  >
                    {r.TimesDone}
                  </td>
                  <td
                    style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}
                    align="center"
                  >
                    {r.Score}
                  </td>
                  <td
                    style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}
                    align="center"
                  >
                    {r.Bricks}
                  </td>
                  <td
                    style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}
                    align="center"
                  >
                    {r.PointsEarned}
                  </td>
                  <td
                    style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}
                    align="center"
                  >
                    {r.PointsUsed}
                  </td>
                  <td
                    style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}
                    align="center"
                  >
                    {r.TotalPoints}
                  </td>
                  <td style={{ ...cellStyle,borderLeft: "1px solid #80a0ff" }}>
                    {r.BonusSource || ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {loading && <Loading />}
      </div>
    </>
  );
};

export default EL_ViewPoints;